module.exports = __webpack_public_path__ + "static/media/fbtb_logo_sketches.7ca66fa8.jpeg";